import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
import cn from 'classnames';
import RecentActorsIcon from '@material-ui/icons/RecentActors';
import { IconButton } from '@material-ui/core';
import SelectField from '../../Fields/SelectField';
import { colors, fontSize } from '../../../constants/styleConstants';
import { repertoireStatuses, TP } from '../../../constants/consts';
import { useTranslation } from '../../../src/i18n';
import DeleteFbIcon from '../../Icons/DeleteFbIcon';

const useStyles = makeStyles(theme => ({
  selectField: {
    width: 120,
    [theme.breakpoints.down('xs')]: {
      width: 84,
    },
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    width: 'calc(100% - 80px)',
    maxWidth: 500,
    [theme.breakpoints.down('xs')]: {
      width: 'calc(100% - 40px)',
    },
  },
  form: {
    display: 'flex',
    alignItems: 'baseline',
  },
  retired: {
    textDecoration: 'line-through',
  },
  voiceType: {
    fontStyle: 'italic',
    marginRight: 10,
  },
  role: {
    width: 'calc(100% - 170px)',
    maxWidth: 340,
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    [theme.breakpoints.down('xs')]: {
      width: 'calc(100% - 134px)',
    },
  },
  futureIcon: {
    display: 'flex',
    alignItems: 'center',
    fontSize: fontSize.textFieldLabel,
    color: colors.darkGrey,
  },
  roleName: {
    marginRight: 10,
  },
}));

export const fields = {
  status: {
    name: 'status',
  },
  actionBlock: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  selectField: {
    minWidth: 100,
  },
};

const RoleSwitch = ({ role, onStatusChange, onDelete }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const repertoireId = get(role, 'repertoireId');
  const [isRetired, setRetired] = React.useState(get(role, 'status') === repertoireStatuses.RETIRED);

  const options = [
    { value: repertoireStatuses.PAST, label: t(`${TP}.ACTIVE`) },
    { value: repertoireStatuses.RETIRED, label: t(`${TP}.RETIRED`) },
  ];
  const [selectValue, setSelectValue] = React.useState(
    get(role, 'status') === repertoireStatuses.RETIRED ? options[1] : options[0],
  );

  const vocal = get(role, 'vocal.type');

  const getRoleName = () => {
    const name = role?.workRole ? 'workRole' : 'profession';
    return get(role, `${name}.name`) || get(role, `${name}.reference`);
  };

  return (
    <div className={classes.container}>
      <div className={cn(classes.role, { [classes.retired]: isRetired })}>
        <div className={classes.roleName}>
          {getRoleName()} {vocal && <span className={classes.voiceType}>({vocal})</span>}
        </div>
        {role.status === repertoireStatuses.WISHLIST && (
          <span className={classes.futureIcon}>
            <RecentActorsIcon style={{ color: colors.concertChip, marginRight: 5 }} />
            {t(`${TP}.m_PREPARED`)}
          </span>
        )}
      </div>
      <div className={classes.actionBlock}>
        <SelectField
          name={fields.status.name}
          field={{
            name: fields.status.name,
            value: selectValue,
          }}
          onChange={v => {
            setRetired(get(v, 'value') === get(options, '[1].value'));
            onStatusChange({ [fields.status.name]: v, repertoireId });
            setSelectValue(v);
          }}
          options={options}
          className={classes.selectField}
        />
        {role.status === repertoireStatuses.WISHLIST && (
          <IconButton onClick={() => onDelete(role)}>
            <DeleteFbIcon />
          </IconButton>
        )}
      </div>
    </div>
  );
};

RoleSwitch.propTypes = {
  onStatusChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  role: PropTypes.object.isRequired,
};

export default RoleSwitch;
